import { CaseDuplicateType, OrganType } from '@/api/apis/case';

export function groupByOrganType(list: CaseDuplicateType[]): Record<OrganType, CaseDuplicateType[]> {
  return list.reduce(
    (acc, dup) => {
      if (!acc[dup.organType]) acc[dup.organType] = [];
      acc[dup.organType].push(dup);
      return acc;
    },
    {} as Record<OrganType, CaseDuplicateType[]>,
  );
}
